var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { height: "100%", width: "auto" },
    },
    [
      _c("div", { staticClass: "modal-card-head centered-items" }, [
        _c("div", { staticClass: "centered-items" }, [
          _c("h2", { staticClass: "title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.collect.enduserCode + " - " + _vm.collect.enduserName
                ) +
                " "
            ),
          ]),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("pages.pickup_management.calendar.collect")) +
                " " +
                _vm._s(_vm.collect.collectId) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "centered-items" },
          [
            _c("b-icon", {
              attrs: {
                icon: "exclamation-triangle",
                type: "is-warning",
                size: "is-large",
              },
            }),
            _c("span", { staticClass: "sub-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pages.pickup_management.collect_confirmation.disclaimer"
                  )
                )
              ),
            ]),
          ],
          1
        ),
        !_vm.showPreview
          ? _c(
              "div",
              [
                _c("b-loading", {
                  attrs: { active: _vm.loading, "is-full-page": "" },
                  on: {
                    "update:active": function ($event) {
                      _vm.loading = $event
                    },
                  },
                }),
                _c("div", { staticClass: "card-content custom-content" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex-row d-flex-space-between" },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "75%" } },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pages.pickup_management.collect_confirmation.emails"
                                )
                              )
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex-justify-center d-flex-row emails",
                            },
                            [
                              _vm._l(_vm.emailsArray, function (email) {
                                return _c(
                                  "b-tag",
                                  {
                                    key: email,
                                    staticClass: "email",
                                    attrs: {
                                      "close-type": "is-danger",
                                      closable: "",
                                      attached: "",
                                    },
                                    on: {
                                      close: function ($event) {
                                        return _vm.removeEmail(email)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(email) + " ")]
                                )
                              }),
                              _c("br"),
                            ],
                            2
                          ),
                          _c("div", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pages.pickup_management.collect_confirmation.additional_email"
                                  )
                                )
                              ),
                            ]),
                            _c(
                              "span",
                              [
                                _c("ValidationObserver", {
                                  ref: "observer",
                                  staticClass: "d-flex-row",
                                  attrs: { tag: "form" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.addEmail.apply(null, arguments)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid }) {
                                          return [
                                            _c("ValidationProvider", {
                                              staticClass: "additional-email",
                                              attrs: {
                                                name: "email",
                                                rules: "email",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "b-field",
                                                          {
                                                            attrs: {
                                                              type: !valid
                                                                ? "is-danger"
                                                                : "",
                                                            },
                                                          },
                                                          [
                                                            _c("b-input", {
                                                              attrs: {
                                                                name: "email",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.additionalMail,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.additionalMail =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "additionalMail",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("b-button", {
                                              staticClass:
                                                "is-info additional-email-button",
                                              attrs: {
                                                "icon-left": "plus",
                                                disabled: !valid,
                                              },
                                              on: { click: _vm.addEmail },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4169521418
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "d-flex-row d-flex-space-between" },
                            [
                              _c(
                                "div",
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "pages.pickup_management.collect_confirmation.templates.use_template"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "b-select",
                                    {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "pages.pickup_management.mail_templates.select_placeholder"
                                        ),
                                      },
                                      model: {
                                        value: _vm.selectedTemplate,
                                        callback: function ($$v) {
                                          _vm.selectedTemplate = $$v
                                        },
                                        expression: "selectedTemplate",
                                      },
                                    },
                                    _vm._l(_vm.templates, function (t) {
                                      return _c(
                                        "option",
                                        { key: t.id, domProps: { value: t } },
                                        [
                                          _vm._v(
                                            " " + _vm._s(t.templateName) + " "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm.selectedTemplate
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "is-primary is-small",
                                          },
                                          on: { click: _vm.useTemplate },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.use")) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "separator" }),
                          _c(
                            "div",
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "pages.pickup_management.collect_confirmation.mail_subject_title"
                                    ),
                                  },
                                },
                                [
                                  _c("b-input", {
                                    attrs: { name: "subject" },
                                    model: {
                                      value: _vm.mailSubject,
                                      callback: function ($$v) {
                                        _vm.mailSubject = $$v
                                      },
                                      expression: "mailSubject",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("ValidationObserver", {
                                ref: "observer2",
                                staticClass: "d-flex-row",
                                attrs: { tag: "form" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ valid }) {
                                        return [
                                          _c("ValidationProvider", {
                                            staticClass: "additional-email",
                                            attrs: {
                                              name: "sender",
                                              rules: "email",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "b-tooltip",
                                                        {
                                                          staticStyle: {
                                                            "margin-top":
                                                              "1rem",
                                                          },
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "pages.pickup_management.collect_confirmation.sender_hint"
                                                            ),
                                                            position:
                                                              "is-right",
                                                          },
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "pages.pickup_management.collect_confirmation.sender"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                          _c("b-icon", {
                                                            staticClass:
                                                              "is-small",
                                                            attrs: {
                                                              icon: "info",
                                                              type: "is-info",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-field",
                                                        {
                                                          attrs: {
                                                            type: !valid
                                                              ? "is-danger"
                                                              : "",
                                                          },
                                                        },
                                                        [
                                                          _c("b-input", {
                                                            attrs: {
                                                              name: "sender",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.mailSender,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.mailSender =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "mailSender",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1715441623
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "pages.pickup_management.collect_confirmation.attachment"
                                ),
                              },
                            },
                            [
                              _c(
                                "b-upload",
                                {
                                  attrs: {
                                    multiple: "",
                                    accept: "application/pdf",
                                    "drag-drop": "",
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.attachments,
                                    callback: function ($$v) {
                                      _vm.attachments = $$v
                                    },
                                    expression: "attachments",
                                  },
                                },
                                [
                                  _c("section", { staticClass: "section" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content has-text-centered",
                                      },
                                      [
                                        _c(
                                          "p",
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon: "file-csv",
                                                size: "is-large",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.loads.drop_file_here"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.attachments && _vm.attachments.length
                                ? _c(
                                    "div",
                                    _vm._l(_vm.attachments, function (at) {
                                      return _c(
                                        "div",
                                        { key: at.name },
                                        [
                                          _c("b-field", [
                                            _c(
                                              "span",
                                              { staticClass: "tag is-info" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(at.name) + " "
                                                ),
                                                _c("button", {
                                                  staticClass:
                                                    "delete is-small",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeAttachment(
                                                        at
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("collectInfoCard", {
                            attrs: { informative: true, collect: _vm.collect },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pages.pickup_management.collect_confirmation.mail_content_title"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      [
                        _c("vue-editor", {
                          model: {
                            value: _vm.mailContent,
                            callback: function ($$v) {
                              _vm.mailContent = $$v
                            },
                            expression: "mailContent",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "b-checkbox",
                        {
                          model: {
                            value: _vm.includeSignature,
                            callback: function ($$v) {
                              _vm.includeSignature = $$v
                            },
                            expression: "includeSignature",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.pickup_management.collect_confirmation.include_signature"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.signature && _vm.includeSignature
                        ? _c(
                            "b-field",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "pages.pickup_management.collect_confirmation.signature"
                                ),
                              },
                            },
                            [
                              _c("signaturePreview", {
                                attrs: {
                                  id: "signatureHTML",
                                  signature: _vm.signature,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex is-justify-content-flex-start is-align-items-center",
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "mr-1 has-text-weight-bold" },
                        [_vm._v("Loading plan:")]
                      ),
                      _c(
                        "b-select",
                        {
                          attrs: {
                            placeholder: "Select a plan",
                            disabled: !_vm.isSelectable,
                            loading: _vm.isPlanLoading,
                          },
                          model: {
                            value: _vm.selectedLoadingPlan,
                            callback: function ($$v) {
                              _vm.selectedLoadingPlan = $$v
                            },
                            expression: "selectedLoadingPlan",
                          },
                        },
                        [
                          _c("option", { domProps: { value: "" } }, [
                            _vm._v(" None "),
                          ]),
                          _vm._l(_vm.loadingPlans, function (lp) {
                            return _c(
                              "option",
                              { key: lp.id, domProps: { value: lp.id } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(lp.attachmentName.split(".")[0]) +
                                    " "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          on: { click: _vm.enableSelection },
                        },
                        [_vm._v(" Change ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex-justify-center buttons" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "is-warning",
                          on: {
                            click: () => {
                              _vm.$emit("close")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "is-info",
                          on: {
                            click: function ($event) {
                              return _vm.loadPreview()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.pickup_management.signature.preview"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "is-primary",
                          on: { click: _vm.submit },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { style: !_vm.showPreview ? "display: none;" : "display: block" },
          [
            _c(
              "b-button",
              {
                staticClass: "is-warning",
                on: {
                  click: () => {
                    _vm.showPreview = !_vm.showPreview
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
            ),
            _c("div", {
              staticClass: "container",
              attrs: { id: "confirmationPreview" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }